var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoRecherche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8,40.3c-0.4,0.4-0.8,0.5-1.3,0.5c-0.5,0-0.9-0.2-1.3-0.5c-0.7-0.7-0.7-1.8-0.1-2.5c4.9-5.2,4.9-13.6,0-18.8 c-0.7-0.7-0.6-1.8,0.1-2.5c0.7-0.7,1.8-0.6,2.5,0.1C48,23.2,48,33.8,41.8,40.3z M59.2,57.2c-0.4,0.4-0.8,0.5-1.3,0.5 s-0.9-0.2-1.3-0.5L44.1,44.7l0,0H44l0,0c-3.7,3.1-8.5,5-13.7,5c-11.6,0-21.1-9.5-21.1-21.2S18.8,7.2,30.5,7.2s21.2,9.5,21.2,21.2 c0,5.2-1.9,10-5,13.7l0,0l0,0l12.6,12.6C60,55.5,60,56.5,59.2,57.2z M30.5,46.1c9.7,0,17.6-7.9,17.6-17.6s-7.9-17.6-17.6-17.6 s-17.6,7.9-17.6,17.6C12.8,38.2,20.7,46.1,30.5,46.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoRecherche);
export default __webpack_public_path__ + "static/media/picto-recherche.114eb7d0c441fc95c4746a8798cb8c48.svg";
export { ForwardRef as ReactComponent };